import { RowCrudStatus } from "../../common/types";
import {
  VatStatus,
  VatStatusCreateMutationVariables,
  VatStatusUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { blankToNull } from "../../../common/blankToNull";

export type VatStatusValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name_es: string;
  name_en: string;
  name_pt: string;
  description_es: string;
  description_en: string;
  description_pt: string;
};

export type VatStatusErrorsType = {
  name_es?: { message: string; fieldLabel: string };
  name_en?: { message: string; fieldLabel: string };
  name_pt?: { message: string; fieldLabel: string };
  description_es?: { message: string; fieldLabel: string };
  description_en?: { message: string; fieldLabel: string };
  description_pt?: { message: string; fieldLabel: string };
};

export function VatStatusValuesInit(): VatStatusValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name_es: "",
    name_en: "",
    name_pt: "",
    description_es: "",
    description_en: "",
    description_pt: "",
  };
}

export type VatStatusType = VatStatus | VatStatusValuesType;

export function vatStatusDisplayId(
  source: Partial<VatStatus>,
  _langStore: LangStore
) {
  return `${source[_langStore.fieldByLang("name") as keyof VatStatusType]}`;
}

export function getVatStatusValues(
  source: VatStatusType,
  _langStore: LangStore,
  _duplicated: boolean = false
): VatStatusValuesType {
  const entityValues = VatStatusValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : vatStatusDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name_es = source.name_es;
  entityValues.name_en = source.name_en;
  entityValues.name_pt = source.name_pt;
  entityValues.description_es = source.description_es || "";
  entityValues.description_en = source.description_en || "";
  entityValues.description_pt = source.description_pt || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getVatStatusUpdateVariables(
  values: VatStatusValuesType
): VatStatusUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
    description_es: blankToNull(values.description_es),
    description_en: blankToNull(values.description_en),
    description_pt: blankToNull(values.description_pt),
  };
}

export function getVatStatusCreateVariables(
  values: VatStatusValuesType
): VatStatusCreateMutationVariables {
  return {
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
    description_es: blankToNull(values.description_es),
    description_en: blankToNull(values.description_en),
    description_pt: blankToNull(values.description_pt),
  };
}
